/**
 * Emulator Port Configuration
 *
 * AUTO-GENERATED from packages/firebase/firebase.json
 * DO NOT EDIT THIS FILE MANUALLY
 *
 * Single source of truth: packages/firebase/firebase.json
 * Generated by: packages/firebase/scripts/generate-emulator-config.mjs
 *
 * These ports are used by Firebase emulators and must match the values
 * in firebase.json for proper emulator connectivity.
 *
 * Standard DF monorepo ports (avoid common dev server conflicts):
 * - Auth: 9155 (standard Firebase port)
 * - Firestore: 8280 (custom, avoids 8000/8080)
 * - Storage: 9390 (standard Firebase port)
 * - Functions: 5501 (customised to avoid conflicts)
 * - UI: 5400 (custom, avoids 4000 range used by Vite)
 */
export const DF_EMULATOR_PORTS = {
    "auth": 9155,
    "firestore": 8280,
    "storage": 9390,
    "functions": 5501,
    "ui": 5400
};
/**
 * Default host for all emulators
 * Uses 127.0.0.1 instead of localhost to avoid IPv6 issues
 */
export const DF_EMULATOR_HOST = '127.0.0.1';
//# sourceMappingURL=emulator-config.js.map